import { fromJS } from 'immutable';
import { basicSort } from '../../../../util/sortUtils';
import {
  refVisibleColumns, tsuVisibleColumns, refSort, tsuSort,
} from '../../../EditReduxConstant';

export const CLEAR_EDIT_MARIGRAM = 'CLEAR_EDIT_MARIGRAM';

export const GET_EDIT_MARIGRAM_REQUEST = 'GET_EDIT_MARIGRAM_REQUEST';
export const GET_EDIT_MARIGRAM_SUCCESS = 'GET_EDIT_MARIGRAM_SUCCESS';
export const GET_EDIT_MARIGRAM_FAILURE = 'GET_EDIT_MARIGRAM_FAILURE';

export const UPDATE_EDIT_MARIGRAM_REQUEST = 'UPDATE_EDIT_MARIGRAM_REQUEST';
export const UPDATE_EDIT_MARIGRAM_SUCCESS = 'UPDATE_EDIT_MARIGRAM_SUCCESS';
export const UPDATE_EDIT_MARIGRAM_FAILURE = 'UPDATE_EDIT_MARIGRAM_FAILURE';

export const CREATE_EDIT_MARIGRAM_REQUEST = 'CREATE_EDIT_MARIGRAM_REQUEST';
export const CREATE_EDIT_MARIGRAM_SUCCESS = 'CREATE_EDIT_MARIGRAM_SUCCESS';
export const CREATE_EDIT_MARIGRAM_FAILURE = 'CREATE_EDIT_MARIGRAM_FAILURE';

export const EDIT_MARIGRAM_TSUNAMI_REQUEST = 'EDIT_MARIGRAM_TSUNAMI_REQUEST';
export const EDIT_MARIGRAM_TSUNAMI_SUCCESS = 'EDIT_MARIGRAM_TSUNAMI_SUCCESS';
export const EDIT_MARIGRAM_TSUNAMI_FAILURE = 'EDIT_MARIGRAM_TSUNAMI_FAILURE';

export const EDIT_MARIGRAM_TSUNAMI_SEARCH_REQUEST = 'EDIT_MARIGRAM_TSUNAMI_SEARCH_REQUEST';
export const EDIT_MARIGRAM_TSUNAMI_SEARCH_SUCCESS = 'EDIT_MARIGRAM_TSUNAMI_SEARCH_SUCCESS';
export const EDIT_MARIGRAM_TSUNAMI_SEARCH_FAILURE = 'EDIT_MARIGRAM_TSUNAMI_SEARCH_FAILURE';

export const EDIT_MARIGRAM_REFERENCE_REQUEST = 'EDIT_MARIGRAM_REFERENCE_REQUEST';
export const EDIT_MARIGRAM_REFERENCE_SUCCESS = 'EDIT_MARIGRAM_REFERENCE_SUCCESS';
export const EDIT_MARIGRAM_REFERENCE_FAILURE = 'EDIT_MARIGRAM_REFERENCE_FAILURE';

export const EDIT_MARIGRAM_REFERENCE_SEARCH_REQUEST = 'EDIT_MARIGRAM_REFERENCE_SEARCH_REQUEST';
export const EDIT_MARIGRAM_REFERENCE_SEARCH_SUCCESS = 'EDIT_MARIGRAM_REFERENCE_SEARCH_SUCCESS';
export const EDIT_MARIGRAM_REFERENCE_SEARCH_FAILURE = 'EDIT_MARIGRAM_REFERENCE_SEARCH_FAILURE';

export const EDIT_MARIGRAM_COUNTRY_REQUEST = 'EDIT_MARIGRAM_COUNTRY_REQUEST';
export const EDIT_MARIGRAM_COUNTRY_SUCCESS = 'EDIT_MARIGRAM_COUNTRY_SUCCESS';
export const EDIT_MARIGRAM_COUNTRY_FAILURE = 'EDIT_MARIGRAM_COUNTRY_FAILURE';

export const EDIT_MARIGRAM_LOCATION_REQUEST = 'EDIT_MARIGRAM_LOCATION_REQUEST';
export const EDIT_MARIGRAM_LOCATION_SUCCESS = 'EDIT_MARIGRAM_LOCATION_SUCCESS';
export const EDIT_MARIGRAM_LOCATION_FAILURE = 'EDIT_MARIGRAM_LOCATION_FAILURE';

export const EDIT_MARIGRAM_STATE_REQUEST = 'EDIT_MARIGRAM_STATE_REQUEST';
export const EDIT_MARIGRAM_STATE_SUCCESS = 'EDIT_MARIGRAM_STATE_SUCCESS';
export const EDIT_MARIGRAM_STATE_FAILURE = 'EDIT_MARIGRAM_STATE_FAILURE';

export const EDIT_MARIGRAM_REFERENCE_SORT = 'EDIT_MARIGRAM_REFERENCE_SORT';
export const EDIT_MARIGRAM_TSUNAMI_SORT = 'EDIT_MARIGRAM_TSUNAMI_SORT';

export const EDIT_MARIGRAM_OPEN_CONFIRMATION = 'EDIT_MARIGRAM_OPEN_CONFIRMATION';
export const EDIT_MARIGRAM_CANCEL_CONFIRMATION = 'EDIT_MARIGRAM_CANCEL_CONFIRMATION';

export const EDIT_MARIGRAM_TSUNAMI_TOGGLE_COLUMN = 'EDIT_MARIGRAM_TSUNAMI_TOGGLE_COLUMN';
export const EDIT_MARIGRAM_REFERENCE_TOGGLE_COLUMN = 'EDIT_MARIGRAM_REFERENCE_TOGGLE_COLUMN';

const initialState = fromJS({
  fetched: false,
  marigram: {
    referenceIds: [],
  },
  updating: false,

  tsunami: {},
  fetchedTsunami: false,
  tsunamiSearchResults: [],
  tsunamiSearching: false,

  references: [],
  fetchedReferences: false,
  referenceSearchResults: [],
  referenceSearching: false,

  fetchedCountries: false,
  countries: [],
  fetchedLocations: false,
  locations: [],
  fetchedStates: false,
  states: [],

  tsuSort,

  refSort,

  refVisibleColumns,
  tsuVisibleColumns,
  formData: {},
  editConfirmationOpen: false,

});

// default param first is the redux convention https://redux.js.org/tutorials/fundamentals/part-3-state-actions-reducers
// eslint-disable-next-line default-param-last
export const marigramEditReducer = (state = initialState, action) => {
  switch (action.type) {
    case CLEAR_EDIT_MARIGRAM:
      return initialState;

    case EDIT_MARIGRAM_OPEN_CONFIRMATION:
      return state.merge(fromJS({
        formData: action.formData,
        editConfirmationOpen: true,
      }));
    case EDIT_MARIGRAM_CANCEL_CONFIRMATION:
      return state.merge(fromJS({
        formData: {},
        editConfirmationOpen: false,
      }));

    case GET_EDIT_MARIGRAM_REQUEST:
      return state.merge(fromJS({
        fetched: false,
        updating: false,
      }));
    case CREATE_EDIT_MARIGRAM_REQUEST:
    case UPDATE_EDIT_MARIGRAM_REQUEST:
      return state.merge(fromJS({
        fetched: false,
        updating: true,
      }));
    case CREATE_EDIT_MARIGRAM_SUCCESS:
    case UPDATE_EDIT_MARIGRAM_SUCCESS:
      return state.merge(fromJS({
        fetched: true,
        marigram: action.response,
        updating: false,
        formData: {},
        editConfirmationOpen: false,
      }));
    case GET_EDIT_MARIGRAM_SUCCESS:
      return state.merge(fromJS({
        fetched: true,
        marigram: action.response,
        updating: false,
      }));
    case CREATE_EDIT_MARIGRAM_FAILURE:
    case UPDATE_EDIT_MARIGRAM_FAILURE:
      return state.merge(fromJS({
        fetched: false,
        updating: false,
        formData: {},
        editConfirmationOpen: false,
      }));
    case GET_EDIT_MARIGRAM_FAILURE:
      return state.merge(fromJS({
        fetched: false,
        updating: false,
      }));

    case EDIT_MARIGRAM_TSUNAMI_SORT:
      return state.merge(fromJS({
        tsunamiSearchResults: basicSort(action.sort, state.get('tsunamiSearchResults')),
        tsuSort: action.sort,
      }));

    case EDIT_MARIGRAM_TSUNAMI_REQUEST:
      return state.merge(fromJS({
        fetchedTsunami: false,
      }));
    case EDIT_MARIGRAM_TSUNAMI_SUCCESS:
      return state.merge(fromJS({
        fetchedTsunami: true,
        tsunami: action.response,
      }));
    case EDIT_MARIGRAM_TSUNAMI_FAILURE:
      return state.merge(fromJS({
        fetchedTsunami: true,
      }));

    case EDIT_MARIGRAM_TSUNAMI_SEARCH_REQUEST:
      return state.merge(fromJS({
        tsunamiSearching: true,
      }));
    case EDIT_MARIGRAM_TSUNAMI_SEARCH_SUCCESS:
      return state.merge(fromJS({
        tsunamiSearching: false,
        tsunamiSearchResults: basicSort(state.get('tsuSort'), fromJS(action.response.items)),
      }));
    case EDIT_MARIGRAM_TSUNAMI_SEARCH_FAILURE:
      return state.merge(fromJS({
        tsunamiSearching: false,
      }));

    case EDIT_MARIGRAM_REFERENCE_SORT:
      return state.merge(fromJS({
        referenceSearchResults: basicSort(action.sort, state.get('referenceSearchResults')),
        refSort: action.sort,
      }));

    case EDIT_MARIGRAM_REFERENCE_REQUEST:
      return state.merge(fromJS({
        fetchedReferences: false,
      }));
    case EDIT_MARIGRAM_REFERENCE_SUCCESS:
      return state.merge(fromJS({
        fetchedReferences: true,
        references: action.response.items,
      }));
    case EDIT_MARIGRAM_REFERENCE_FAILURE:
      return state.merge(fromJS({
        fetchedReferences: true,
      }));

    case EDIT_MARIGRAM_REFERENCE_SEARCH_REQUEST:
      return state.merge(fromJS({
        referenceSearching: true,
      }));
    case EDIT_MARIGRAM_REFERENCE_SEARCH_SUCCESS:
      return state.merge(fromJS({
        referenceSearching: false,
        referenceSearchResults: basicSort(state.get('refSort'), fromJS(action.response.items)),
      }));
    case EDIT_MARIGRAM_REFERENCE_SEARCH_FAILURE:
      return state.merge(fromJS({
        referenceSearching: false,
      }));

    case EDIT_MARIGRAM_COUNTRY_REQUEST:
      return state.merge(fromJS({
        fetchedCountries: false,
      }));
    case EDIT_MARIGRAM_COUNTRY_SUCCESS:
      return state.merge(fromJS({
        fetchedCountries: true,
        countries: action.response.items,
      }));
    case EDIT_MARIGRAM_COUNTRY_FAILURE:
      return state.merge(fromJS({
        fetchedCountries: true,
      }));

    case EDIT_MARIGRAM_LOCATION_REQUEST:
      return state.merge(fromJS({
        fetchedLocations: false,
      }));
    case EDIT_MARIGRAM_LOCATION_SUCCESS:
      return state.merge(fromJS({
        fetchedLocations: true,
        locations: action.response.items,
      }));
    case EDIT_MARIGRAM_LOCATION_FAILURE:
      return state.merge(fromJS({
        fetchedLocations: true,
      }));

    case EDIT_MARIGRAM_STATE_REQUEST:
      return state.merge(fromJS({
        fetchedStates: false,
      }));
    case EDIT_MARIGRAM_STATE_SUCCESS:
      return state.merge(fromJS({
        fetchedStates: true,
        states: action.response.items,
      }));
    case EDIT_MARIGRAM_STATE_FAILURE:
      return state.merge(fromJS({
        fetchedStates: true,
      }));

    case EDIT_MARIGRAM_TSUNAMI_TOGGLE_COLUMN:
      return state.merge(fromJS({
        tsuVisibleColumns: action.visibleColumns,
      }));

    case EDIT_MARIGRAM_REFERENCE_TOGGLE_COLUMN:
      return state.merge(fromJS({
        refVisibleColumns: action.visibleColumns,
      }));

    default:
      return state;
  }
};
